import { css } from "lit";

export const styles = css`
  .share-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    overflow: auto;
  }

  .promo-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .section-title {
    margin: 0;
    font-size: var(--sds-typography-body-size-large);
    font-weight: 600;
    color: var(--sds-color-text-primary);
  }

  .section-subtitle {
    margin: 0;
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-secondary);
  }

  .promo-content {
    display: flex;
    gap: 16px;
  }

  .promo-preview {
    flex-shrink: 0;
    border-radius: 12px;
    overflow: hidden;
    background-color: var(--sds-color-background-neutral-secondary);
  }

  .promo-preview.horizontal {
    width: 320px;
    aspect-ratio: 16 / 9;
    flex: 1;
  }

  .promo-preview.vertical {
    width: 200px;
    aspect-ratio: 9 / 16;
  }

  .promo-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    text-align: center;
    color: var(--sds-color-text-secondary);
    font-size: 14px;
  }

  .share-actions {
    display: flex;
    flex-direction: column;
  }

  .share-action-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: var(--sds-typography-body-size-large);
    font-weight: 500;
    color: var(--sds-color-text-primary);
    transition: background-color 0.2s ease;
    text-align: left;
  }

  .share-action-btn:hover {
    background-color: var(--sds-color-background-neutral-secondary);
  }

  .share-action-btn:active {
    background-color: var(--sds-color-background-neutral-tertiary);
  }

  .link-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 24px;
    border-top: 1px solid var(--sds-color-border-default-default);
  }

  .link-title {
    margin: 0;
    font-size: var(--sds-typography-body-size-large);
    font-weight: 600;
    color: var(--sds-color-text-primary);
  }

  .link-subtitle {
    margin: 0;
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-secondary);
  }

  .link-row {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .link-input-container {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background-color: var(--sds-color-background-neutral-secondary);
    border-radius: 8px;
    color: var(--sds-color-text-secondary);
  }

  .link-input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-primary);
    outline: none;
    min-width: 0;
  }

  .copy-link-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: transparent;
    background-color: var(--sds-color-background-default-secondary);

    border: 1px solid var(--sds-color-border-default-default);
    border-radius: 8px;
    cursor: pointer;
    font-size: var(--sds-typography-body-size-medium);
    font-weight: 500;
    color: var(--sds-color-text-primary);
    white-space: nowrap;
    transition: all 0.2s ease;
  }

  .copy-link-btn:hover {
    background-color: var(--sds-color-background-neutral-secondary);
  }

  .copy-link-btn.copied {
    background-color: var(--sds-color-background-positive-secondary);
    border-color: var(--sds-color-border-positive-default);
    color: var(--sds-color-text-positive-primary);
  }

  @media (max-width: 768px) {
    .share-content {
      padding: 0;
    }

    .promo-content {
      flex-direction: column;
      align-items: center;
    }

    .promo-preview.horizontal {
      width: 90%;
      max-height: 220px;
    }

    .promo-preview.vertical {
      width: 100%;
      max-width: 200px;
    }

    .share-actions {
      width: 100%;
    }

    .link-section {
      padding-top: 0;
      border-top: none;
    }

    .link-row {
      flex-direction: column;
      align-items: stretch;
    }

    .copy-link-btn {
      justify-content: center;
    }
  }
`;
